var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPC)?_c('div',[_c('Pc')],1):_c('div',[_c('Mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }